import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('access_token');
const clearTokens = () => localStorage.removeItem('access_token');

export const authAxios = axios.create();
authAxios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await authAxios.get(`${API}/auth/me`);
      setUser(data);
    } catch {
      clearTokens();
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (username, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { username, password });
    localStorage.setItem('access_token', data.access_token);
    setUser({ role: data.role, name: data.name, tc_accepted: data.tc_accepted });
    return data;
  };

  const logout = async () => {
    try { await authAxios.post(`${API}/auth/logout`); } catch {}
    clearTokens();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
